import axiosInstance from "../api";
import { notification } from "antd";

// get question master
export const getAllQuestionMaster = async ({
  skip = 0,
  limit = 10,
  name = "",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("search", name);

    const response = await axiosInstance.get(
      `/plan_questions/admin_all_from_question?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Form Question",
      description:
        response?.data?.message || "Failed to fetch form Questions list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching Form Questions",
      description:
        error.response?.data?.message || "Failed to fetch Form Questions list.",
      duration: 3,
    });
    throw new Error("Error fetching Form Question list");
  }
};

  
export const addQuestionOption = async ({ id, ...payload }) => {
  try {
    var url = `/plan_questions/admin_create_form_questions_options`
    if (id){
      url = `/plan_questions/admin_update_form_questions_options`
    }
    const response = await axiosInstance.post(
      url,
      {
        id,
        ...payload,
      }
    );
    if (response.data.status_code === 200) {
      var description = "Form question added successfully!"
      if (id){
        description = "Form question updated successfully!"
      }

      notification.success({
        message: "Success",
        description: description,
      });
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
      return false;
    }

    return response.data; // needed for useMutation's onSuccess
  } catch (error) {
    const message =
      error?.response?.data?.message || "Failed to add/update form question";

    notification.error({
      message: "Error",
      description: message,
      duration: 3,
    });

    throw error; // important so React Query knows it failed
  }
};

// get user form submission list
export const getAllUserFormList = async ({
  skip = 0,
  limit = 10,
  name = "",
  userId = "",
  start_date = null,
  end_date = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("search", name);
    if (userId) params.append("user_id", userId);

    if(start_date && end_date){
      params.append("start_date", start_date);
      params.append("end_date", end_date);
    }

    const response = await axiosInstance.get(
      `/plan_questions/admin_user_form_question?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Form Question",
      description:
        response?.data?.message || "Failed to fetch form Questions list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching Form Questions",
      description:
        error.response?.data?.message || "Failed to fetch Form Questions list.",
      duration: 3,
    });
    throw new Error("Error fetching Form Question list");
  }
};

// active question
export const activateDeactivateQuestion = async (updateId, active) => {
  try {
    const payload = { id : updateId, active: active}
    const response = await axiosInstance.put(`/plan_questions/activate_deactivate`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error");
  }
};

// update config

export const updateFormPlanConfig = async (payload) => {
  try {
    const response = await axiosInstance.post(`/plan_questions/enable_form_plan`, {'config_data':payload});

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error");
  }
};

export const downloadUserForms = async ({
  user_id=null, 
  start_date=null, 
  end_date=null,
  search=null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (user_id) params.append("user_id", user_id);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (search) params.append("search", search);

    const response = await axiosInstance.get(`/plan_questions/admin_user_form_question_export?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // extract filename from Content-Disposition header
      console.log(response.headers)
      const disposition = response.headers["content-disposition"];
      let filename = "user_forms_report.xlsx"; // fallback
      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, ""); // remove quotes if present
      }
      a.download = filename; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      return response; 
    } else {
      throw new Error("Download failed"); 
    }
  } catch (error) {
    console.error("Error downloading user forms:", error);
    notification.error({
      message: "Error Downloading Users forms",
      description: error.response?.data?.message || "Failed to download user forms.",
      duration: 3,
    });
    throw error; 
  }
};